import {
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import {useNavigate} from 'react-router-dom';

import LoadingIndicator from '../../components/loading-indicator';
import {AppContent, ContentRow} from '../../styled/components';
import TableHeader from '../../components/table-header';
import ConfirmDeletion from '../../components/confirm-deletion';
import useBEDatatable from '../../hooks/use-be-datatable';
import {deleteCountry, getCountries} from './api-service';

function Countries() {
  const navigate = useNavigate();

  const {
    ready,
    instancesList,
    filter,
    numberOfPages,
    page,
    rangeEnd,
    rangeStart,
    totalInstances,
    selectedInstance,
    showDeleteConfirm,

    setPage,
    filterChange,
    deleteInstance,
    setShowDeleteConfirm,
    handleDeleteButtonClicked,
  } = useBEDatatable({
    loadInstancesServiceAction: getCountries,
    deleteInstanceServiceAction: deleteCountry,
  });

  return (
    <>
      {!ready && <LoadingIndicator/>}
      <AppContent>
        <TableHeader
          title="Countries"
          showAddButton
          handleAddButtonClicked={() => navigate('/contacts/countries/new')}
          filter={filter}
          filterChange={filterChange}
          firstItemIndex={rangeStart}
          lastItemIndex={rangeEnd}
          totalItems={totalInstances}
        />
        <ContentRow>
          {ready && (
            <TableContainer component={Paper}>
              <Table sx={{minWidth: 650}} aria-label="countries table">
                <TableHead>
                  <TableRow>
                    <TableCell>Country Name</TableCell>
                    <TableCell>Country Code</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {instancesList.length > 0 && instancesList.map((country) => (
                    <TableRow
                      key={`country-${country.id}`}
                      sx={{'td': {paddingTop: 1, paddingBottom: 1}, '&:last-child td, &:last-child th': {border: 0}}}
                    >
                      <TableCell>{country.name}</TableCell>
                      <TableCell>{country.code || ''}</TableCell>
                      <TableCell align="right">
                        <IconButton
                          size="small"
                          aria-label="show country"
                          onClick={() => navigate(`/contacts/countries/${country.id}`)}
                        >
                          <VisibilityIcon fontSize="small"/>
                        </IconButton>
                        <IconButton
                          size="small"
                          aria-label="delete country"
                          onClick={() => handleDeleteButtonClicked(country)}
                        >
                          <DeleteIcon fontSize="small"/>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                  {instancesList.length === 0 && (
                    <TableRow>
                      <TableCell align="center" colSpan={3}>
                        <Typography>There are no Countries yet. Add the first one by clicking the "Add new" button</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </ContentRow>
        {numberOfPages > 1 && (
          <ContentRow style={{display: 'flex', justifyContent: 'center', columnGap: 16}}>
            <Pagination
              count={numberOfPages}
              page={page}
              variant="text"
              shape="rounded"
              color="primary"
              showFirstButton
              showLastButton
              onChange={(ev, p) => setPage(p)}
            />
          </ContentRow>
        )}
      </AppContent>
      {showDeleteConfirm && (
        <ConfirmDeletion
          handleClose={() => setShowDeleteConfirm(false)}
          handleConfirm={() => deleteInstance(selectedInstance)}
          deleteInstanceMsg={`country "${selectedInstance?.name || ''}"`}
        />
      )}
    </>
  );
}

export default Countries;
